// Forms: Ajax
// ----------------------------------------

function initForms() {
	const forms = document.querySelectorAll('form[data-form="true"]');

	forms.forEach((form) => {
		if (!form.name) {
			console.error('Ajax forms must have a unique name.');
			return;
		}
		if (form.dataset.form === 'initialized') {
			return;
		}

		form.dataset.form = 'initialized';
		form.addEventListener('submit', (e) => {
			e.preventDefault();
			handleSubmit(form);
		});

		initFormAutocomplete(form);
		initFormToggles(form);
	});
}

// Forms: Autocomplete
// ----------------------------------------

const AUTOCOMPLETE_OPTIONS = {
	types: ['address'],
	fields: ['address_component'],
	componentRestrictions: {
		country: 'nz'
	}
};

async function initFormAutocomplete(form) {
	const inputs = form.querySelectorAll('[data-autocomplete]');

	inputs.forEach((input) => {
		const components = [
			{
				type: 'street_number',
				input: form.querySelector(input.dataset.autocompleteNumber)
			},
			{
				type: 'route',
				input: form.querySelector(input.dataset.autocompleteStreet)
			},
			{
				type: 'sublocality_level_1',
				input: form.querySelector(input.dataset.autocompleteSuburb)
			},
			{
				type: 'locality',
				input: form.querySelector(input.dataset.autocompleteCity)
			},
			{
				type: 'postal_code',
				input: form.querySelector(input.dataset.autocompletePostCode)
			},
			{
				type: 'country',
				input: form.querySelector(input.dataset.autocompleteCountry)
			}
		];

		// Set initial value, if any
		components.forEach((component) => {
			if (component.input.value) {
				if (input.value) {
					input.value += ' ';
				}
				input.value += component.input.value;
			}
		});

		const autocomplete = new google.maps.places.Autocomplete(input, AUTOCOMPLETE_OPTIONS);

		google.maps.event.addListener(autocomplete, 'place_changed', () => {
			fillInputs(autocomplete, components);
		});

		input.addEventListener('blur', () => {
			if (!input.value) {
				clearInputs(components);
			}
		});
	});
}

// Forms: toggles
// ----------------------------------------

function initFormToggles(form) {
	const toggles = form.querySelectorAll('input[type=checkbox][data-toggle]');

	toggles.forEach((toggle) => {
		const el = form.querySelector(toggle.dataset.toggle);
		const timeline = gsap.timeline({paused: true}).fromTo(
			el,
			{
				display: 'none',
				opacity: 0,
				x: 50
			},
			{
				duration: 0.4,
				display: 'block',
				opacity: 1,
				x: 0
			}
		);

		if (toggle.checked) {
			timeline.totalProgress(1);
		}

		toggle.addEventListener('change', async (e) => {
			if (toggle.checked) {
				await timeline.play();
			} else {
				await timeline.reverse();

				el.querySelectorAll('input').forEach((input) => {
					input.value = null;
				});
			}
		});
	});
}

// Functions
// ----------------------------------------

async function handleSubmit(form) {
	if (form.classList.contains('-loading')) return;

	const eventSubmit = new CustomEvent('form:submit');
	const eventSuccess = new CustomEvent('form:success');
	const eventError = new CustomEvent('form:error');
	const btn = form.querySelector('[type="submit"]');
	const data = new FormData(form);
	const redirectUrl = form.dataset.redirect;
	const replace = form.dataset.replace || true;

	form.dispatchEvent(eventSubmit);
	form.classList.add('-loading');
	btn.classList.add('-loading');

	data.append(btn.name, 1); // Add button name to data for symphony event

	// logFormData(data);

	const res = await ajax('POST', form.action, data);
	const parser = new DOMParser();
	const newDoc = parser.parseFromString(res, 'text/html');
	const newForm = newDoc.querySelector(`form[name="${form.name}"]`);

	if (!newForm) {
		console.log(`No form matching the selector form[name="${form.name}"] was found`);
		form.classList.remove('-loading');
		btn.classList.remove('-loading');
		return;
	}

	if (newForm.dataset.status === 'success') {
		if (redirectUrl) {
			navigateTo(redirectUrl);
		} else if (replace !== 'false') {
			form.innerHTML = newForm.innerHTML;
			form.classList.remove('-loading');
			btn.classList.remove('-loading');

			initFormAutocomplete(form);
			initFormToggles(form);
		}

		form.dispatchEvent(eventSuccess);
	} else {
		form.innerHTML = newForm.innerHTML;
		form.classList.remove('-loading');
		btn.classList.remove('-loading');

		initFormAutocomplete(form);
		initFormToggles(form);

		form.dispatchEvent(eventError);
	}
}

function logFormData(data) {
	for (var pair of data.entries()) {
		console.log(pair[0] + ', ' + pair[1]);
	}
}

function fillInputs(autocomplete, components) {
	const place = autocomplete.getPlace();

	if (!place) {
		console.error('No Place was provided, clearing inputs.');
		clearInputs(components);
		return;
	}

	if (!place.address_components) {
		console.error(`User entered the name of a Place that was not suggested ${place.name}, clearing inputs.`);
		clearInputs(components);
		return;
	}

	components.forEach((component) => {
		let val = null;

		place.address_components.forEach((ac) => {
			if (ac.types[0] == component.type) {
				val = ac.long_name;
				return;
			}
		});

		component.input.value = val;
	});
}

function clearInputs(components) {
	components.forEach((component) => (component.input.value = null));
}

// Events
// ----------------------------------------

$DOC.ready(() => {
	initForms();
});

$WINDOW.on('page:load-completed', (e) => {
	initForms();
});
